import { FC, useEffect } from 'react';
import EditorVideo from 'lowcode/components/EditorVideo';
import EditorImg from 'lowcode/components/EditorImg';
import styled from './index.module.scss';
import { useLang } from '@/app/utils/useLang';
import getLocal from '@/app/utils/getLocal';
import { EU_LIST } from '@/components/XPower/constants';

const beginImg: Record<string, { pc: string; h5: string }> = {
    us: {
        pc: 'https://ecoflow-service-us-cdn.ecoflow.com/upload/image/1718951380174/%E7%BC%96%E7%BB%841.jpg',
        h5: 'https://ecoflow-service-us-cdn.ecoflow.com/upload/image/1718951345978/%E7%A7%BB%E5%8A%A8%E7%AB%AF%E6%88%BF%E5%AD%90.jpg',
    },
};

const Second: FC = () => {
    const { t } = useLang('xcode.xfusion.second');
    const { locale } = getLocal();

    useEffect(() => {
        if (typeof window !== 'undefined') {
            // 305 190是结束节点的宽高 419 352是结束时相对end_img容器定位 xEnd yEnd是图片缩放后偏移量 scaleEnd根据最终宽高计算缩放比
            const isMobile = window.innerWidth <= 768; // h5样式节点
            if (isMobile) return;

            const endWidth = isMobile ? 120 : 305;
            const endHeight = isMobile ? 70 : 170;
            const endLeft = isMobile ? 132 : 352;
            const endTop = isMobile ? 325 : 419;

            const scaleEnd = Math.min(endWidth / window.innerWidth, endHeight / window.innerHeight);
            const leftEnd = (document.querySelector('#x-fusion-second .end .end_img') as any).offsetLeft + endLeft;
            const yEnd = (window.innerHeight - endHeight) / 2;
            const xEnd = (window.innerWidth - endLeft) / 2;

            const sceneA = AniContainer.create({
                asyncFromTo: [
                    [
                        '#x-fusion-second .begin',
                        { scale: 1, top: 0, left: 0, y: 0, x: 0 },
                        { scale: scaleEnd, top: endTop, left: leftEnd, y: -yEnd, x: -xEnd },
                        2,
                    ],
                    ['#x-fusion-second .end', { opacity: 0 }, { opacity: 1 }, 1],
                    ['#x-fusion-second .end .left', { x: -300 }, { x: 0 }, 1],
                    ['#x-fusion-second .begin .begin_img', { opacity: 1 }, { opacity: 0 }, 1],
                    ['#x-fusion-second .end .center', { scale: 3.5 }, { scale: 1 }, 1],
                    ['#x-fusion-second .end .cover_img', { scale: 3.5, opacity: 0 }, { scale: 1, opacity: 1 }, 1],
                    ['#x-fusion-second .end .right', { x: 300 }, { x: 0 }, 1],
                    ['#x-fusion-second .end .text', { y: 300 }, { y: 0 }, 1],
                ],
                asyncTimeLine: [0, 1, 1, 0.75, 1, 1, 1, 1],
                triggerElement: '#x-fusion-second',
                triggerHook: 1,
                offset: '100%',
                duration: '200%',
            });
            AniContainer.scrollHandle(); //执行一次初始化
            return () => AniContainer.removeScene(sceneA);
        }
    }, []);

    return (
        <div className={styled.Second} id="x-fusion-second">
            <div className="sticky">
                <div className="begin">
                    {/* <EditorVideo autoPlay loop src="https://ecoflow-service-us-cdn.ecoflow.com/upload/video/1717121518286/KV_H.264.mp4" /> */}
                    {/* <EditorVideo
                        className="begin_img"
                        src="https://ecoflow-service-us-cdn.ecoflow.com/upload/video/1717394878402/Navigate%20Power%20with%20Intelligence.mp4"
                        src="https://ecoflow-service-us-cdn.ecoflow.com/upload/video/1717209462685/Navigate%20Power%20with%20Intelligence.webm"
                        autoPlay
                        loop
                    /> */}
                    <EditorImg className="begin_img" alt={t('title')} pc={beginImg[locale]?.pc || beginImg.us.pc} h5={beginImg[locale]?.h5 || beginImg.us.h5} />
                </div>
                <div className="end">
                    <div className="middle-central">
                        <div className="end_img">
                            <div className="left">
                                <EditorImg
                                    pc="https://ecoflow-service-us-cdn.ecoflow.com/upload/image/1718951184233/web%E7%94%B5%E8%84%91%403x%201.png"
                                    alt={t('title')}
                                />
                            </div>
                            <div className="center">
                                <EditorImg pc="https://ecoflow-service-us-cdn.ecoflow.com/upload/image/1718701958681/monitor.png" alt={t('title')} />
                            </div>
                            <div className="center cover_img">
                                <EditorImg
                                    pc="https://ecoflow-service-us-cdn.ecoflow.com/upload/image/1718951146066/%E5%85%BC%E5%AE%B9%E6%96%B9%E6%A1%88-%E6%99%9A%E4%B8%8A%403x%201.jpg"
                                    alt={t('title')}
                                />
                            </div>
                            <div className="right">
                                <EditorImg pc="https://ecoflow-service-us-cdn.ecoflow.com/upload/image/1718951169856/App.png" alt={t('title')} />
                            </div>
                        </div>
                        <div className="text">
                            <h6 className="title">{t('title')}</h6>
                            <p className="subtitle font-desc">{t('subtitle')}</p>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default Second;
